import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import Toast from '../common/Toast';
import PropTypes from 'prop-types';
import { Spin, Icon } from 'antd';
import AgentLayout from './AgentLayout';

/**
 * Agent Page of the app.
 *
 * @component
 * @category Agent Page
 */

class AgentPage extends Component {
  state = {
    tokenFetched: false, // Track whether the token has been fetched
  };

  componentWillMount = () => {
    //don't do data polling by uuid if on landing page
    const dataPolling = false;

    this.props.setDataPolling(dataPolling, () => {
      //Get auth params from the url.
      this.props.getInitAuth(this.getRemoteData);
    });
  };


  getRemoteData = async () => {
    await this.props.getJWTForAgent(); // Wait for JWT token fetching to complete
    this.setState({ tokenFetched: true }); // Update state to indicate token is available
  };

  render() {
    const { tokenFetched } = this.state;
    return (
      <div
        style={{
          height: 'auto',
          // minHeight:'100vh',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
        }}
        className="testO1"
      >
       {/* Show spinner while waiting for JWT token */}
       {!tokenFetched && //<Spin size="large" className="spinner" />
        <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width:"100%",
                height:"100vh"
              }}
            >
              <Spin style={{
                    marginLeft: '10px',
                    marginRight: '10px',
                  }}
                  indicator={<Icon type="loading" style={{ fontSize: 48 }} spin />}
              />
            </div>
       }


        {/* show toast message if there is error message */}
        {this.props.errorMessage.trim() && <Toast />}

         {/* Conditionally render AgentLocatorPage only when token is fetched */}
         {tokenFetched && (
        <div
          style={{
            // display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          className="testR1"
        >
          <AgentLayout />
        </div>
         )}
      </div>
    );
  }
}

AgentPage.propTypes = {
  /**
   * Global error message
   */
  errorMessage: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    errorMessage: state.route.errorMessage,
  };
};

export default connect(mapStateToProps, actions)(AgentPage);
